module.exports = __webpack_public_path__ + "img/page62.740c229f.gif";